<template>
  <transition name="router-anim">
    <div class="kits">
      <div class="top-panel">
        <DescriptionModal class="description-modal" 
          :description="`This page displays a list of admin users.`" />
      </div>
      <div class="kits-title">
        <div class="title first-name">
          FIRST NAME
        </div>
        <div class="title last-name">
          LAST NAME
        </div>
        <div class="title email">
          EMAIL
        </div>
        <div class="title date" @click="sortedBy">
          REGISTRATION DATE
          <img
            src="../../images/dashboard/up.png"
            alt="#"
            v-if="sortedByState === 'desc'"
          />
          <img
            class="down"
            src="../../images/dashboard/up.png"
            alt="#"
            v-else
          />
        </div>
      </div>
      <div class="kits-item" v-for="item in admins">
        <div
          class="kit-desc first-name"
          @click="
            openAdmin(item.first_name, item.last_name, item.email, item.id)
          "
        >
          {{ item.first_name }}
        </div>
        <div class="kit-desc last-name">
          {{ item.last_name }}
        </div>
        <div class="kit-desc email">
          <span>{{ item.email }}</span>
        </div>
        <div class="kit-desc date">
          {{ date(item.created_at) }}
        </div>
        <button
          title="Delete"
          class="remove-icon-btn"
          @click="remove(item.id, item.first_name, item.last_name)"
        >
          <Remove></Remove>
        </button>
      </div>
      <div class="pogination">
        <Paginate
          v-if="count_page > 1"
          :page-count="count_page"
          :page-class="'pogination-item'"
          :click-handler="changePage"
          :prev-text="'<'"
          :next-text="'>'"
          :container-class="'pogination-wrap'"
        ></Paginate>
      </div>
    </div>
  </transition>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import { mapActions } from "vuex";
import Paginate from "vuejs-paginate";
import Remove from "../../images/dashboard/Remove";

export default {
  name: "Admins",
  data() {
    return {
      admins: null,
      count_page: 1,
      sortedByState: "desc"
    };
  },
  components: {
    Remove,
    Paginate
  },
  methods: {
    ...mapActions([
      "setAdminPginationPage",
      "getAdminInfoList",
      "setSortedByAdmin"
    ]),
    changePage(item) {
      this.setAdminPginationPage(item).then(() => {
        this.getAdminInfoList("admins");
      });
    },
    sortedBy() {
      if (this.sortedByState === "desc") {
        this.sortedByState = "asc";
      } else {
        this.sortedByState = "desc";
      }
      this.setSortedByAdmin(this.sortedByState).then(() => {
        this.getAdminInfoList("admins");
      });
    },
    remove(id, firstName, lustName) {
      this.$emit("confurmDelAdmin", {
        show: true,
        id,
        fullname: `${firstName} ${lustName}`
      });
    },
    date(localDate) {
      return localDate;
      // if (localDate !== null) {
      //   let date = new Date(localDate);
      //   return moment(date).format("MM/DD/YYYY");
      // }
    },
    openAdmin(first_name, last_name, email, id) {
      this.$emit("showAdminInfo", {
        first_name,
        last_name,
        id,
        email,
        show: true
      });
    }
  },
  computed: {
    ...mapGetters(["getAdmins"])
  },
  watch: {
    pogination(num) {
      this.count_page = num;
    },
    getAdmins(obj) {
      this.admins = obj;
    }
  },
  mounted() {
    this.admins = this.$store.getters.getAdmins;
    if (this.$store.getters.adminPogination !== null) {
      this.count_page = this.$store.getters.adminPogination;
    }
  }
};
</script>

<style scoped>
.kits {
  margin: 40px 0 0 0;
}
.title.date .down {
  transform: rotate(180deg);
}
.kits-title {
  display: flex;
  justify-content: space-between;
  margin: 0 0 30px 0;
  padding: 0 30px;
}
.title {
  color: #b3b3b3;
  font-size: 14px;
  font-family: TTNormsMedium, sans-serif;
}
.title.first-name {
  min-width: 300px;
  width: 100%;
}
.kit-desc.first-name {
  min-width: 300px;
  width: 100%;
  cursor: pointer;
}
.kit-desc.first-name:hover {
  color: #005eb8;
  font-family: TTNormsRegular, sans-serif;
}
.title.last-name {
  min-width: 300px;
  width: 100%;
}
.kit-desc.last-name {
  min-width: 300px;
  width: 100%;
}
.title.email {
  min-width: 320px;
  width: 100%;
}
.kit-desc.email {
  min-width: 320px;
  width: 100%;
}
.kit-desc.email span {
  overflow: hidden;
  width: 98%;
  display: inline-block;
}
.title.date {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  width: 100%;
  position: relative;
  cursor: pointer;
}
.title.date img {
  margin-top: -2px;
  max-width: 7px;
  height: 14px; 
}
.kit-desc.date {
  padding: 0 20px 0 0;
  min-width: 160px;
  width: 100%;
}
.kits-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 30px;
  background-color: #fff;
  margin: 10px 0;
  border-radius: 5px;
}
.kits-item:hover {
  background-color: #e0e9f4;
}
.kit-desc {
  color: #58595b;
  font-size: 14px;
  font-family: TTNormsLight, sans-serif;
}
.remove-icon-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  background-color: transparent;
  border: none;
  outline: none;
  width: 10px;
}
.pogination {
  margin: 20px 0 0 0;
}
.top-panel {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  margin-top: 30px;
}
.description-modal{
  text-align: end;
  position: absolute;
  z-index: 1;
  width: 100%;
}
</style>
